import { Accordion as AccordionType } from '@/types';
import React, { Suspense } from 'react';
import Loading from './Loading';

const Accordions = React.lazy(() => import('./Accordions'));

type Props = {
  className?: string;
  accordions: AccordionType[];
};

function SuspendedAccordions(props: Props) {
  return (
    <Suspense fallback={<Loading {...props} />}>
      <Accordions {...props} />
    </Suspense>
  );
}

export default SuspendedAccordions;
